import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tag } from '@tryhackme/thm-ui-components';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';

export const StyledCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.6rem;
  width: 100%;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
`;

export const StyledWrapper = styled.div`
  position: relative;
  border: 0.1rem solid #d4d8df;
  border-radius: 0.4rem;
`;

export const StyledSummary = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.4rem 1.8rem;
  border-radius: 0.4rem;
  gap: 1.6rem;
`;

export const StyledSummaryHeader = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  gap: 1.2rem;
  cursor: pointer;
`;

export const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.colors.black};
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  width: 3rem;
  height: 3rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.68rem;
  background-color: #e7eefc;

  > svg {
    position: absolute;
  }

  > span {
    position: absolute;
    font-size: 1.3rem;
    line-height: 3.2rem;
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.info.main};
  font-size: medium;
`;

export const StyledTitle = styled.span`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;

export const StyledTag = styled(Tag)`
  margin-right: 0.8rem;
  padding: 0.7rem 1.4rem;
  white-space: nowrap;

  svg {
    display: none;
  }
`;

export const StyledChevronIcon = styled(FontAwesomeIcon)<{ isOpen: boolean }>`
  color: ${({ theme }) => theme.colors.info.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  transform: rotate(${({ isOpen }) => (isOpen ? '-180deg' : '0deg')});
  transition: transform 0.3s ease;
`;

export const StyledBody = styled(CSSTransition)`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem 1.6rem 1.6rem;
`;

export const StyledCheckbox = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: ${({ theme }) => theme.fonts.sizes.default};
  white-space: nowrap;
`;
